import { render, staticRenderFns } from "./PickInvestorDialog.vue?vue&type=template&id=86758894&"
import script from "./PickInvestorDialog.vue?vue&type=script&lang=js&"
export * from "./PickInvestorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports